import CONF from '@/Config.js';
import axios from 'axios';

export default {
    authInapp: function(type, id, ref)
    {
        var data = ref === null ? {
            payload: id
        } : {
            payload: id, 
            referenceCode: ref
        }

        return axios({
            method: 'post',
            url: CONF.AUTH_INAPP.replace("${type}", type),
            data: data
        })
    },
    fetchUserVisitInfos: function(uuid)
    {
        return axios({
            method: 'get',
            url: CONF.FETCH_USER_VISIT_INFOS.replace("${uuid}", uuid),
        })
    },
    fetchShortUrl: function(key)
    {
        return axios({
            method: 'get',
            url: `${CONF.FETCH_SHORT_URL}${key}`
        })
    },
    fetchHospitalInfos: function(uuid)
    {
        return axios({
            method: 'get',
            headers: {
                'Authorization': '.KK9vp3Kaa7pHU8Vvjx7BQg3xsVcU_'
            },
            url: CONF.FETCH_HOSPITAL_INFOS.replace("${uuid}", uuid)
        })
    },
    sendEventCode: function(eventName, eventCode, time)
    {
        var data = {
            bridgeCompany: "SLEEPQ",
            eventName: eventName,
            referenceCode: eventCode,
            timestamp: time
        }

        return axios({
            method: 'post',
            url: CONF.SEND_EVENT_CODE,
            data: data
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/tele.js